import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import CaesarCipher from "./CaesarCipher";
import firebase from "firebase/compat/app";
import SymmetricEncryption from "./SymmetricEncryption";
import { Element, scroller } from "react-scroll";

const Chapter4_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist der Unterschied zwischen symmetrischer und asymmetrischer Verschlüsselung?",
      options: [
        {
          value: "A",
          label:
            "Symmetrische Verschlüsselung verwendet denselben Schlüssel für Verschlüsselung und Entschlüsselung, asymmetrische zwei unterschiedliche Schlüssel.",
        },
        {
          value: "B",
          label:
            "Symmetrische Verschlüsselung ist sicherer als asymmetrische Verschlüsselung.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welcher Algorithmus wird häufig für die symmetrische Verschlüsselung genutzt?",
      options: [
        {
          value: "A",
          label: "RSA (Rivest-Shamir-Adleman).",
        },
        {
          value: "B",
          label: "AES (Advanced Encryption Standard).",
        },
      ],
      correct: "B",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 4_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
   
    auth
      .signOut()
      .then(() => {
       
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "4_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("4_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 4_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "4_4",
              completedChapters: ["4_4"],
            });
          console.log("Dokument erstellt mit Kapitel 4_4");
        }

        navigate("/4_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  4. Netzwerk und Netzwerksicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Datenverschlüsselung
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            Kapitel 4. Netzwerk und Netzwerksicherheit
          </h3>
          <h2 className="text-center p-3">Datenverschlüsselung</h2>
          <img
            src="/images/netzwerkprotokoll.webp"
            alt="netzwerkprotokoll"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">
            Sichere Netzwerkkommunikation durch Datenverschlüsselung
          </h2>
          <p className="col-lg-11 mx-auto">
            Die Verschlüsselung der Daten ist das zentrale Element der{" "}
            <strong> sicheren Kommunikation in Netzwerken. </strong> Die
            Datenverschlüsselung schützt die Informationen, indem sie sie in
            einen unlesbaren Code umwandelt, der nur mit einem Schlüssel
            entschlüsselt werden kann. Selbst wenn ein Angreifer Zugriff auf die
            verschlüsselten Daten erhält, bleiben sie wertlos, solange der
            Schlüssel sicher bleibt.
            <br />
            <br />
            Kunden, Partner und Regulierungsbehörden erwarten, dass Unternehmen
            ihre Daten proaktiv schützen. Regulierungen wie die
            Datenschutz-Grundverordnung (GDPR) verlangen sogar den Einsatz von
            Verschlüsselung.
          </p>
          <h3 className="p-5">Die zwei Ebenen der Verschlüsselung</h3>
          <p className="col-lg-10 pb-5  mx-auto">
            <strong>1. Verschlüsselung während der Übertragung: </strong>
            <br />
            <br />
            Datenpakete, die durch Netzwerke fließen sind anfällig für
            Abhörversuche.{" "}
            <Link to="/4_2#ssl" className="icon-link">
              <svg className="bi" aria-hidden="true">
                <use xlinkHref="#book"></use>
              </svg>{" "}
              Sicherheitsprotokolle
            </Link>
            wie Transport Layer Security (TLS) sorgen dafür, dass diese
            Informationen während der Übertragung verschlüsselt werden. Dies ist
            beispielsweise der Fall, wenn du eine Website über HTTPS besuchst.
            <br />
            <br />
            <Element name="aes">
              <strong>2. Verschlüsselung im Ruhezustand: </strong>
              <br />
              <br />
              Daten, die auf Festplatten, Servern oder in der Cloud gespeichert
              sind, können durch Verschlüsselung besser geschützt werden. Eine
              gängige Methode zur Verschlüsselung ist AES (Advanced Encryption
              Standard). AES nutzt den gleichen Schlüssel für das Verschlüsseln
              und Entschlüsseln von Daten. Je länger der Schlüssel, desto mehr
              mögliche Kombinationen gibt es, was die Sicherheit erhöht. AES
              wird weltweit eingesetzt, weil es schnell und sicher ist und gegen
              bekannte Angriffe geschützt ist, solange der Schlüssel sicher
              bleibt.
            </Element>
            <br />
            <br />
            Trotz ihrer Stärke hat die Verschlüsselung auch ihre
            Herausforderungen. Ein verlorener Schlüssel kann dazu führen, dass
            Daten unwiederbringlich verloren sind. Ein robustes
            Schlüsselmanagement kann dies verhindern. Zudem erfordert die
            Implementierung von Verschlüsselungstechnologien eine sorgfältige
            Planung und kontinuierliche Wartung.
          </p>
        </div>

        <div className="gelb-section">
          <div className="container">
            <div className="p-5 text-center">
              <h2 className="p-5">Wie funktioniert Verschlüsselung?</h2>
              <p className="pt-3 col-lg-11 mx-auto">
                Verschlüsselung wandelt Klartext-Daten in einen unlesbaren Code
                um, den nur autorisierte Personen mit dem entsprechenden
                Entschlüsselungsschlüssel wieder in die ursprüngliche Form
                zurückverwandeln können.
              </p>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Eine der ältesten und einfachsten Verschlüsselungsmethoden ist
                die Caesar-Verschlüsselung. Sie wurde tatsächlich von Julius
                Caesar in der Antike verwendet. Bei der Caesar-Verschlüsselung
                wird jeder Buchstabe in einer Nachricht durch einen anderen
                ersetzt, indem das Alphabet um eine festgelegte Anzahl von
                Positionen verschoben wird. Der Empfänger weiß genau, um
                wie viele Positionen er die Buchstaben wieder zurück schieben
                muss um die Nachricht korrekt lesen zu können.
              </p>
              <p className=" col-lg-9 mx-auto">
                <CaesarCipher />
              </p>
              <p className="p-5 col-lg-11 mx-auto">
                Die Caesar-Verschlüsselung ist eine sehr einfache Form der
                Substitutionsverschlüsselung, bei der jeder Buchstabe durch
                einen anderen Buchstaben ersetzt wird, der um eine festgelegte
                Anzahl im Alphabet verschoben ist. Diese Methode wird als
                monoalphabetische Substitution bezeichnet, weil immer dieselbe
                Regel auf jeden Buchstaben angewendet wird. Obwohl sie in der
                Zeit von Julius Caesar wirksam war, ist sie leicht zu knacken,
                weil es nur eine begrenzte Anzahl von möglichen Verschiebungen
                gibt (25), und keine moderne Kryptographie-Methoden
                berücksichtigt werden.
                <br />
                <br />
                Heute ist die Verschlüsselung viel komplexer, und statt
                Buchstaben werden Zahlen in einem festgelegten Muster
                verschoben. Aber die Grundidee ist die gleiche: Nur wer den
                richtigen Schlüssel hat, kann die Nachricht wieder entschlüsseln
                und lesen. Dies geschieht mit Hilfe von Kryptografischen
                Algorithmen, die auf komplexen mathematischen Verfahren
                basieren. Zwei der gängigsten Methoden sind die Symmetrische und
                die Asymmetrische Verschlüsselung
              </p>
            </div>
          </div>
        </div>

        <div className="grey-section">
          <div className="container">
            <div className="p-5 text-center">
              <h2 className="p-5">Symmetrische Verschlüsselung</h2>
              <p className=" p-3 col-lg-11 mx-auto">
                In der symmetrischen Verschlüsselung bleibt die Idee der
                Caesar-Verschlüsselung, dass{" "}
                <strong>
                  {" "}
                  derselbe Schlüssel für die Verschlüsselung und Entschlüsselung{" "}
                </strong>{" "}
                verwendet wird, erhalten. Jedoch sind die Algorithmen und
                Schlüssel viel komplexer. Ein Beispiel für symmetrische
                Verschlüsselung ist der Advanced Encryption Standard (AES), der
                in vielen modernen Netzwerken verwendet wird, um Daten in
                Echtzeit zu schützen. Statt einfacher Buchstabenverschiebungen
                arbeitet AES mit Binärcodes (also Nullen und Einsen). Die
                Schlüssel sind 128, 192 oder 256 Bits lang.
                <br />
                <br />
                Dabei ist jedes Bit eine einzelne Stelle im Code, die entweder
                eine 0 oder eine 1 sein kann (also zwei mögliche Zustände). Ein
                Schlüssel von 128 Bits besteht also aus einer Kombination von
                128 Nullen und Einsen. Da jede Stelle zwei Möglichkeiten hat (0
                oder 1), gibt es insgesamt 2^128 mögliche Schlüssel. Das sind
                340 Sextillionen (eine extrem große Zahl) verschiedene
                Kombinationen, die ein potenzieller Angreifer ausprobieren
                müsste, um den Schlüssel zu erhalten.
                <br />
                <br />
                Bei einem 256-Bit-Schlüssel gibt es noch viel mehr mögliche
                Kombinationen, nämlich 2^256. Das ist eine noch viel größere
                Zahl, die die Sicherheit erhöht, weil es unglaublich schwierig
                ist, den richtigen Schlüssel durch{" "}
                <Link to="/2_3#brute" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  Brute-Force-Angriffe
                </Link>{" "}
                (Ausprobieren) zu erraten. Je mehr Bits, desto mehr mögliche
                Schlüssel gibt es, und desto sicherer ist die Verschlüsselung,
                weil es exponentiell schwieriger wird, den Schlüssel zu knacken.
              </p>

              <p className=" col-lg-9 mx-auto">
                <SymmetricEncryption />
              </p>
            </div>
          </div>
        </div>
        <div className="white-section">
          <div className="container">
            <div className="p-5 text-center">
              <h3 className="p-5">Asymmetrische Verschlüsselung</h3>
              <p className=" p-3 col-lg-11 mx-auto">
                Diese Methode verwendet ein Schlüsselpaar, bestehend aus einem
                <strong> öffentlichen Schlüssel </strong> und einem{" "}
                <strong> privaten Schlüssel. </strong> Der öffentliche Schlüssel
                wird verwendet, um Daten zu verschlüsseln, während der private
                Schlüssel ausschließlich zum Entschlüsseln dient. Der
                öffentliche Schlüssel ist im übertragenen Sinne ein Art
                "Briefkasten", in dem jeder die Post an dich einwerfen kann.
                Aber nur durch den privaten Schlüssel kannst du den Briefkasten
                öffnen und die Post herausholen. Die asymmetrische
                Verschlüsselung wird häufig bei der End-to-End-Verschlüsselung
                oder in SSL/TLS-Zertifikaten für sichere Webkommunikation
                verwendet. Sie ist sehr sicher, aber rechenintensiver als
                symmetrische Verfahren.
                <br />
                <br />
                Für die asymmetrische Verschlüsselung werden die Techniken RSA
                und ECC genutzt. Beim{" "}
                <strong> RSA (Rivest-Shamir-Adleman) </strong> werden sehr große
                Primzahlen in ihre Primfaktoren zerlegt und damit werden sehr
                lange Schlüssel erzeugt. Diese besonders rechenleistungsintensive
                Technik bietet zwar eine hohe Sicherheit aber macht durch ihre
                langen Schlüssel die Übertragung langsam. Die{" "}
                <strong> ECC (Elliptic Curve Cryptography) </strong> verwendet
                x- und y-Punkte auf mathematischen elliptischen Kurven um Daten
                zu verschlüsseln. Der öffentliche Schlüssel gibt zwar den Anfang
                und das Ende der Kurve bekannt, man weiß aber nicht, wie viele
                Zwischenschritte entlang der Kurve gemacht wurden. Das wird nur
                durch den privaten Schlüssel sichtbar. Obwohl RSA am
                verbreitesten ist, wird das modernere ECC zunehmend bevorzugt.
                Es bietet bei kleinerer Schlüssellänge die gleiche Sicherheit
                wie RSA. Es ist schneller und effizienter, besonders für mobile
                Geräte oder Systeme mit wenig Rechenleistung.
                <br />
                <br />
                Beide Verfahren sind jedoch durch die Entwicklung von
                Quantencomputern potenziell gefährdet, weshalb in der Zukunft
                sogenannte{" "}
                <strong> post-quantum Verschlüsselungsverfahren </strong>{" "}
                notwendig sein werden.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />

          <h3 className="p-5">
            Veränderung der Datenverschlüsselung durch Quantentechnologie
          </h3>
          <p className="p-3 col-lg-11 mx-auto">
            Ein <strong>Quantencomputer </strong>funktioniert völlig anders als
            ein klassischer Computer. Während ein normaler Computer
            Informationen in Form von Bits speichert, die nur zwei Zustände
            haben – 1 oder 0 –, nutzt ein Quantencomputer sogenannte{" "}
            <strong> Qubits. </strong> Diese Qubits können nicht nur 1 oder 0
            sein, sondern auch beide Zustände gleichzeitig (das nennt man{" "}
            <strong> Superposition).</strong> Dadurch kann ein Quantencomputer
            viele Rechenwege gleichzeitig ausprobieren, was ihm ermöglicht,
            extrem komplizierte Probleme viel schneller zu lösen als
            herkömmliche Computer.
            <br />
            <br />
            Das hat große Auswirkungen auf die Verschlüsselung von Daten.
            Heutige Verschlüsselungsverfahren wie RSA oder ECC basieren darauf,
            dass klassische Computer bestimmte mathematische Probleme, wie das
            Zerlegen einer großen Zahl in ihre Bestandteile, nicht schnell genug
            lösen können. Ein Quantencomputer mit einem speziellen Algorithmus
            (dem bereits 1994 von Peter Shor entwickelten Shor's Algorithmus)
            kann diese Probleme aber sehr schnell lösen. Das bedeutet, dass er
            die heutigen Verschlüsselungen leicht „knacken“ könnte.
            <br />
            <br />
            Duch einen leistungsstarken Quantencomputer, wären viele unserer
            aktuellen Sicherheitssysteme, wie verschlüsselte E-Mails,
            Online-Banking oder digitale Signaturen, nicht mehr sicher. Daten,
            die heute geschützt scheinen, könnten in Zukunft von
            Quantencomputern entschlüsselt werden.
            <br />
            <br />
            Wissenschaftler arbeiten bereits an neuen Verschlüsselungstechniken,
            die auch für Quantencomputer zu kompliziert sind. Zusätzlich gibt es
            Ideen wie die <strong> Quantenkryptografie, </strong> die mit den
            besonderen Eigenschaften der Quantenmechanik arbeitet, um Daten noch
            sicherer zu machen. Eine Möglichkeit wäre es, mit jedem Datenpaket
            kleine Lichtteilchen (Protonen) mit zu versendet. Diese Protonen
            verändern ihren Zustand bei jeder Aktion von außen, so dass z. B.
            ein Abhören der Daten sofort bemerkt werden könnte.
          </p>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-11 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter4_4;
